import Products from "../features/products"

export const ProductsPage = () => {
  return (
   <Products/>
  )
}